import { Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { useTranslationRankmi } from 'helpers/translations.helper'
import InputLabel from 'components/ui/forms/field/input-label/InputLabel'
import Button, { ButtonVariant, ButtonSizes } from 'design-system/button'
import { prefix, prefixButtons } from '../constants'
import Note from './Note'
import { IMainState } from 'store/states'

interface NotesProps {
  value?: string[]
  onChange: (value: string[]) => void
}

export const Notes = ({ value = [], onChange }: NotesProps) => {
  const { t } = useTranslation()
  const synchronousCourse = useSelector(
    ({ courses }: IMainState) => courses.course.synchronousCourse
  )

  const maximumGrade = synchronousCourse?.maximumGrade

  const tRelative = useTranslationRankmi({
    prefix,
  })

  const getValue = (value: string) => {
    const number = +value

    if (maximumGrade && number > maximumGrade) return `${maximumGrade}`
    return number < 0 ? '0' : value
  }

  return (
    <Row>
      <Col xs={12}>
        <InputLabel label={tRelative(`notes`)} />{' '}
      </Col>
      {(!value?.length ? [''] : value).map((note, index) => (
        <Col key={index} xs={12} className={`my-1`}>
          <Note
            value={note}
            onChange={(newNote) => {
              const newValue = [...value]
              newValue[index] = getValue(newNote)
              onChange(newValue)
            }}
            onRemove={() => {
              onChange(value.filter((_, i) => i !== index))
            }}
          />
        </Col>
      ))}
      <Col xs={12} className="d-flex justify-content-center">
        <Button
          outline
          className={`py-2`}
          variant={ButtonVariant.Secondary}
          size={ButtonSizes.ExtraSmall}
          onClick={() => {
            onChange([...value, ''])
          }}
        >
          <FontAwesomeIcon className="mr-2" icon={faPlus} />
          {t(`${prefixButtons}.addNote`)}
        </Button>
      </Col>
    </Row>
  )
}

export default Notes
